import { render, staticRenderFns } from "./accountsReceivable.vue?vue&type=template&id=0af2c174&scoped=true&"
import script from "./accountsReceivable.vue?vue&type=script&lang=js&"
export * from "./accountsReceivable.vue?vue&type=script&lang=js&"
import style0 from "./accountsReceivable.vue?vue&type=style&index=0&id=0af2c174&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af2c174",
  null
  
)

export default component.exports